import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';
import "./index.css";
import App from "./App";
import './i18n';

const rootElement = document.getElementById("root");

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// When the route was prerendered (react-snap-style static HTML written by
// scripts/prerender.js), the #root element already has markup — hydrate it.
// Otherwise (dev / un-prerendered route), mount a fresh client root.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
